import { get } from './httpClient'

export const getBookings = (query) => get('/booking', query)
export const getBookingStatistic = (query) => get('/booking/booking-statistic', query)